import createReducer from '../../helpers/CreateReducer';
import { SagaConstants } from '../../constants/actions';

interface LoadedAction {
  loaded: boolean;
  reloadAfterLogout: boolean;
}

interface SagaState {
  loadedActions: Record<string, LoadedAction>;
  loadingActions: string[];
  noPersistance: boolean;
}

export const getInitialState = (): SagaState => ({
  loadedActions: {},
  loadingActions: [],
  noPersistance: true
});

export default createReducer(getInitialState, {
  [`${SagaConstants.SAGA_DATA_LOADED}`]: (
    state: SagaState,
    payload: { action: string; reloadAfterLogout?: boolean }
  ) => ({
    loadedActions: {
      ...state.loadedActions,
      [payload.action]: {
        loaded: true,
        reloadAfterLogout:
          payload.reloadAfterLogout ||
          (state.loadedActions[payload.action] &&
            state.loadedActions[payload.action].reloadAfterLogout)
      }
    }
  }),
  [`${SagaConstants.RESET_DATA_LOADED}`]: (
    state: SagaState,
    payload: { loadedActions: Record<string, LoadedAction> }
  ) => ({
    loadedActions: payload.loadedActions
  }),
  [`${SagaConstants.START_LOADING}`]: (
    state: SagaState,
    { actionType }: { actionType: string }
  ) => ({
    loadingActions: [
      ...state.loadingActions.filter(i => i !== actionType),
      actionType
    ]
  }),
  [`${SagaConstants.END_LOADING}`]: (
    state: SagaState,
    { actionType }: { actionType: string }
  ) => ({
    loadingActions: [...state.loadingActions.filter(i => i !== actionType)]
  })
});
